import { CalendarDays } from "lucide-react";
import { daysAgo, today, fyStart, ytdStart } from "@/lib/utils";

interface FilterBarProps {
  from: string;
  to: string;
  onFromChange: (val: string) => void;
  onToChange: (val: string) => void;
  showPresets?: boolean;
  children?: React.ReactNode;
}

const PRESETS = [
  { label: "7d", from: () => daysAgo(7) },
  { label: "30d", from: () => daysAgo(30) },
  { label: "90d", from: () => daysAgo(90) },
  { label: "YTD", from: ytdStart },
  { label: "FY", from: fyStart },
] as const;

export function FilterBar({
  from,
  to,
  onFromChange,
  onToChange,
  showPresets = true,
  children,
}: FilterBarProps) {
  const todayStr = today();

  function isActive(presetFrom: () => string): boolean {
    return from === presetFrom() && to === todayStr;
  }

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-border bg-card p-3">
      <div className="flex items-center gap-2">
        <CalendarDays className="h-4 w-4 text-muted-foreground" />
        <input
          type="date"
          value={from}
          onChange={(e) => onFromChange(e.target.value)}
          className="rounded-md border border-input bg-background px-3 py-1.5 text-sm text-foreground"
        />
        <span className="text-muted-foreground text-sm">to</span>
        <input
          type="date"
          value={to}
          onChange={(e) => onToChange(e.target.value)}
          className="rounded-md border border-input bg-background px-3 py-1.5 text-sm text-foreground"
        />
      </div>
      {showPresets && (
        <div className="flex gap-1">
          {PRESETS.map((p) => (
            <button
              key={p.label}
              onClick={() => {
                onFromChange(p.from());
                onToChange(todayStr);
              }}
              className={`rounded-md px-2.5 py-1 text-xs font-medium transition-colors ${
                isActive(p.from)
                  ? "bg-primary text-primary-foreground"
                  : "bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground"
              }`}
            >
              {p.label}
            </button>
          ))}
        </div>
      )}
      {children}
    </div>
  );
}
